module.exports = __webpack_public_path__ + "static/media/preparing.cf22e390.gif";